export enum CompanyResourceFilter {
  Benefits = 'benefits',
  Locations = 'locations',
  Departments = 'departments',
  JobPostings = 'job_postings',
  Surveys = 'surveys',
}
